import { lazy } from 'react';

const OrganizationList = lazy(() => import('./OrganizationList'));

const OrganizationConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'organization',
      element: <OrganizationList />,
    },
  ],
};

export default OrganizationConfig;
